<!-- <mat-nav-list>
    <mat-form-field style="width:100%;margin-top: 2%;">
        <input matInput placeholder="{{'MENU1.SEARCH_MENU' | translate}}" value="" id="search" />
    </mat-form-field>
    <tv-menu-item *ngFor="let item of menuItems; let i= index" [menuItem]="item" [sideNav]="sideNav" id="{{'Id'+i}}">
    </tv-menu-item>
</mat-nav-list> -->
<!-- <mat-nav-list>
    <tv-menu-item *ngFor="let item of menuItems" [menuItem]="item" [sideNav]="sideNav"></tv-menu-item>
</mat-nav-list>
<mat-nav-list> -->
  <!-- <mat-nav-list>
    <mat-form-field class="menu-css">
      <input matInput placeholder="Search Menu" value="" id="search" />
    </mat-form-field>
    <tv-menu-item *ngFor="let item of menuItems; let i = index" [menuItem]="item" [sideNav]="sideNav" id="{{'Id' + i}}">
    </tv-menu-item>
  </mat-nav-list> -->

  <mat-nav-list>
    <div class="menu-css">
      <div class="menu-logo">
        <img src="../../assets/bankverve.png" style="width:70px;"/>
    </div>
      <div class="input-container">
        <input type="text" placeholder="Search Menu" id="search" class="search-input" />
        <span class="search-icon">🔍</span>
         </div>
    </div>
    <tv-menu-item *ngFor="let item of menuItems; let i = index" [menuItem]="item" [sideNav]="sideNav" id="{{'Id' + i}}">
    </tv-menu-item>
  </mat-nav-list>
  
  
